import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Postrequestcall } from "../../request/Postrequest";
import { SEARCH_PRODUCTS } from "../../constant/Apipath";
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tab,
  Tabs,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import SearchField from "../common/SearchField";
import { BIBlue, BIRed } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import InfiniteScroll from "react-infinite-scroll-component";
import AddProductModal from "../common/AddProductModal";
import { useNavigate } from "react-router-dom";
import { setShowReport } from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import Pageheader from "../common/Pageheader";
import Emptydata from "../common/Emptydata";
import { AddButton } from "../common/AddButton";
import BuildIcon from "@mui/icons-material/Build";
import { English } from "../../constant/EnglishFallback";
import Pages from "../../constant/ReportModel";
import VerifiedIcon from "@mui/icons-material/Verified";
import { CompaniesSkeleton, ProductsSkeleton } from "../skeleton/SkeletonView";
import AdContainer from "../common/AdContainer";

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`
  };
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography component="span">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const Products = () => {
  const { loginData, multiLanguageData, reportSuccess } = useSelector((state) => state?.main);
  const currentUserId = loginData?.userInformation?.UserId ?? 0;
  const LanguageData = multiLanguageData?.Products || {};
  const {
    TEXT_PRODUCTS = English.Products.TEXT_PRODUCTS,
    TEXT_ALL_PRODUCTS = English.Products.TEXT_ALL_PRODUCTS,
    TEXT_MY_PRODUCTS = English.Products.TEXT_MY_PRODUCTS,
    TEXT_ALL = English.Products.TEXT_ALL,
    TEXT_PRODUCTS_ARRAY_TOOLS = English.Products.TEXT_PRODUCTS_ARRAY_TOOLS,
    TEXT_PRODUCTS_ARRAY_MATERIALS = English.Products.TEXT_PRODUCTS_ARRAY_MATERIALS,
    TEXT_ROUNDED_TABS_WORK_WITH = English.Products.TEXT_ROUNDED_TABS_WORK_WITH,
    TEXT_FOLLOWING = English.Products.TEXT_FOLLOWING,
    TEXT_RESULTS = English.Products.TEXT_RESULTS,
    TEXT_SEARCH_PRODUCTS = English.Products.TEXT_SEARCH_PRODUCTS,
    BUTTON_ADD_PRODUCT = English.Products.BUTTON_ADD_PRODUCT,
    BUTTON_REPORT = English.Products.BUTTON_REPORT,
    TEXT_ADD_PRODUCT = English.Products.TEXT_ADD_PRODUCT,
    NO_RESULT = English.Products.NO_RESULT
  } = LanguageData || {};

  let myProductsArray = [
    { name: "Worked With", value: TEXT_ROUNDED_TABS_WORK_WITH },
    { name: "Following", value: TEXT_FOLLOWING }
  ];
  let productsTypeArray = [
    { name: "All", value: TEXT_ALL },
    { name: "Tools", value: TEXT_PRODUCTS_ARRAY_TOOLS },
    { name: "Materials", value: TEXT_PRODUCTS_ARRAY_MATERIALS }
  ];

  let navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [nrOfRecords, setNrOfRecords] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [pageNr, setPageNr] = useState(1);
  const [recordId, setRecordId] = useState([]);
  const [productTabValue, setProductTabValue] = useState(0);
  const [myProducysTabValue, setMyProductsTabValue] = useState("Worked With");
  const [allProductsTabValue, setAllProductsTabValue] = useState("All");
  const [showAddItemModal, setShowAddItemModal] = useState(false);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const [selectAllProductMenu, setSelectAllProductMenu] = useState("All");
  const [selectMyProductMenu, setSelectMyProductMenu] = useState("Worked With");

  useEffect(() => {
    if (reportSuccess !== true) fetchData(searchTerm, pageNr, "All");
  }, [reportSuccess]);

  const getObjectForProductSearch = (searchTerm, pageNo, searchTypeValue) => {
    let obj = {
      UserId: Number(currentUserId),
      SearchString: searchTerm ?? "",
      ProductType: "All",
      MyProductCategory: "",
      PageNumber: pageNo ?? 1,
      NrRowsPerPage: 100
    };

    if (searchTypeValue === "All") {
      return obj;
    }
    if (searchTypeValue === "Tools") {
      return { ...obj, ProductType: "Tool" };
    }
    if (searchTypeValue === "Materials") {
      return { ...obj, ProductType: "Material" };
    }

    if (searchTypeValue === "Worked With") {
      return { ...obj, MyProductCategory: "worked with", ProductType: "" };
    }

    if (searchTypeValue === "Following") {
      return { ...obj, MyProductCategory: "following", ProductType: "" };
    }
    return obj;
  };

  const fetchData = async (searchTerm, pageNo, searchType) => {
    try {
      if (pageNo === 1) {
        setIsLoading(true);
      }
      setAllDataLoaded(true);
      let searchTypeValue = searchType;
      if (searchTypeValue === "check_type") {
        searchTypeValue = productTabValue === 0 ? allProductsTabValue : myProducysTabValue;
      }
      let obj = getObjectForProductSearch(searchTerm, pageNo, searchTypeValue);
      const res = await Postrequestcall(SEARCH_PRODUCTS, obj, loginData?.accessToken);
      const resData = res?.data?.data || [];
      let updatedData = resData.filter((value) => value != null || value != undefined);
      // if (searchTypeValue === "All" || searchTypeValue === true) {
      //   updatedData = resData.filter(
      //     (value) => value?.manufacturerName?.trim() !== ""
      //   )
      // }

      if (updatedData.length > 0) {
        updatedData = updatedData.sort((a, b) =>
          a.name
            ? a.name?.toLowerCase().localeCompare(b.name?.toLowerCase())
            : a.productName?.toLowerCase().localeCompare(b.productName?.toLowerCase())
        );
      }
      setData((prevData) => (pageNo === 1 ? updatedData : [...prevData, ...updatedData]));
      setNrOfRecords(res?.data?.nrOfRecords || 0);
      setAllDataLoaded(false);
      setIsLoading(false);
    } catch (error) {
      console.error("fetchData-> Error fetching data: ", error);
    } finally {
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    // Manual search only - user must click the search icon or press Enter
  };

  const handleMenuOpen = (event, item) => {
    event.stopPropagation();
    setMoreMenuAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleMenuClose = () => setMoreMenuAnchorEl(null);

  const handleLoadMore = async () => {
    if (data.length < nrOfRecords) {
      await fetchData(searchTerm, pageNr + 1, "check_type");
      setPageNr((prevPage) => prevPage + 1);
    }
  };

  const handleChangeProductTab = async (event, newValue) => {
    setProductTabValue(newValue);
    setPageNr(1);
    setSearchTerm("");
    if (newValue === 0) {
      setSelectAllProductMenu("All");
      setAllProductsTabValue("All");
    } else {
      setSelectMyProductMenu("Worked With");
      setMyProductsTabValue("Worked With");
    }
    await fetchData("", 1, newValue === 0 ? "All" : "Worked With");
  };

  const getProductSecondaryValue = (item) => {
    if (item?.productType && item?.manufacturerName) {
      return `${item.productType} | ${item.manufacturerName}`;
    }
    if (item?.productType) {
      return item.productType;
    }
    if (item?.manufacturerName) {
      return item.manufacturerName;
    }
    return "Unknown";
  };

  const handleViewReport = () => {
    setMoreMenuAnchorEl(null);
    let reportObj = {
      showReport: true,
      recordId: recordId.id ?? 0,
      name: Pages?.product?.name,
      AppScreenId: Pages?.product?.id
    };
    dispatch(setShowReport(reportObj));
  };

  const handleTopMenuClick = async (menuItem, params) => {
    if (params === "allProduct") {
      setSelectAllProductMenu(menuItem);
      setAllProductsTabValue(menuItem);
    } else {
      setMyProductsTabValue(menuItem);
      setSelectMyProductMenu(menuItem);
    }
    setPageNr(1);
    setSearchTerm("");
    fetchData("", 1, menuItem);
  };

  const handleAddPostClick = (event) => {
    event.target.blur();
    setShowAddItemModal(true);
  };

  const renderListing = () => {
    return (
      <Box className="main-content-card-list" id="scrollablediv_prodcut">
        {data.length !== 0 ? (
          <InfiniteScroll
            dataLength={data?.length}
            next={handleLoadMore}
            hasMore={data.length < nrOfRecords}
            loader={
              !allDataLoaded ? null : (
                <h4 style={{ display: "flex", justifyContent: "center" }}>
                  <Loader />
                </h4>
              )
            }
            scrollableTarget="scrollablediv_prodcut">
            <List disablePadding>
              <Stack sx={{ gap: 1 }} >
                {data?.map((item, index) => (
                  <Card
                    key={index}
                    onClick={() => {
                      navigate(`/product/${item?.id}`);
                    }}
                    className="pagelist-content">
                    <ListItem
                      key={index}
                      secondaryAction={
                        <IconButton
                          onClick={(event) => {
                            handleMenuOpen(event, item);
                            setRecordId(item);
                          }}>
                          <MoreIcon />
                        </IconButton>
                      }
                      disablePadding>
                      <ListItemButton>
                        <ListItemText
                          primary={
                            <Stack sx={{ gap: 0.4 }} direction={"row"} >
                              {item?.name}
                              {item?.verified && (
                                <VerifiedIcon
                                  sx={{
                                    color: BIBlue,
                                    fontSize: "1.2rem"
                                  }}
                                />
                              )}
                            </Stack>
                          }
                          secondary={getProductSecondaryValue(item)}
                        />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                ))}
              </Stack>
            </List>
          </InfiniteScroll>
        ) : (
          <Box className="empty-data-card">
            <Emptydata icon={<BuildIcon className="emptydata-icon" />} firstText={NO_RESULT} />
          </Box>
        )}
      </Box>
    );
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3, pt: 2 }}>
      <Pageheader headerName={TEXT_PRODUCTS} />
      <Card className="main-content-card">
        <Grid container spacing={{ xs: 1, md: 2 }} sx={{ pb: 1,  alignItems: "center" }} >
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
            <Tabs
              variant="fullWidth"
              aria-label="basic tabs example"
              value={productTabValue}
              onChange={handleChangeProductTab}>
              <Tab label={TEXT_ALL_PRODUCTS} {...a11yProps(0)} />
              <Tab label={TEXT_MY_PRODUCTS} {...a11yProps(1)} />
            </Tabs>
          </Grid>
          <Grid size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
            <SearchField
              size={"small"}
              value={searchTerm}
              onChange={handleSearchChange}
              onSubmit={() => fetchData(searchTerm, 1, "check_type")}
              onClear={() => {
                setSearchTerm("");
                setPageNr(1);
                fetchData("", 1, "check_type");
              }}
              searchIconOutside
              placeholder={TEXT_SEARCH_PRODUCTS}
            />
          </Grid>
          <Grid sx={{ display: "flex", justifyContent: { xs: "flex-start", md: "flex-end" } }} size={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
            <Typography variant="h6" sx={{ color: "text.secondary" }}>
              {nrOfRecords} {TEXT_RESULTS}
            </Typography>
          </Grid>
        </Grid>

        <TabPanel value={productTabValue} index={0}>
          <Stack spacing={1}>
            <Divider />
            <Stack spacing={2} sx={{ pb: 1.5 }} direction={"row"}>
              {productsTypeArray.map((menu, index) => {
                const isSelected = menu.name === selectAllProductMenu;
                return (
                  <Button
                    size="large"
                    key={index}
                    label={menu.value}
                    variant={"contained"}
                    color={isSelected ? "primary" : "inherit"}
                    style={{
                      textTransform: "none",
                      borderRadius: "20px"
                    }}
                    onClick={() => handleTopMenuClick(menu.name, "allProduct")}>
                    {menu.value}
                  </Button>
                );
              })}
            </Stack>
          </Stack>
        </TabPanel>
        <TabPanel value={productTabValue} index={1}>
          <Stack spacing={1}>
            <Divider />
            <Stack spacing={2} sx={{ pb: 1.5 }} direction={"row"}>
              {myProductsArray.map((menu, index) => {
                const isSelected = menu.name === selectMyProductMenu;
                return (
                  <Button
                    size="large"
                    key={index}
                    label={menu.value}
                    variant={"contained"}
                    color={isSelected ? "primary" : "inherit"}
                    style={{
                      textTransform: "none",
                      borderRadius: "20px"
                    }}
                    onClick={() => handleTopMenuClick(menu.name, "myProduct")}>
                    {menu.value}
                  </Button>
                );
              })}
            </Stack>
          </Stack>
        </TabPanel>
        {isLoading ? <ProductsSkeleton /> : renderListing()}
        <AddButton toolTipText={BUTTON_ADD_PRODUCT} onAddClick={handleAddPostClick} />
        <AdContainer />
      </Card>

      {moreMenuAnchorEl && (
        <Menu
          anchorEl={moreMenuAnchorEl}
          open={Boolean(moreMenuAnchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}>
          <MenuItem
            style={{ color: BIRed }}
            dense
            onClick={() => {
              handleViewReport();
            }}>
            {BUTTON_REPORT}
          </MenuItem>
        </Menu>
      )}

      {showAddItemModal && (
        <AddProductModal
          open={showAddItemModal}
          onClose={() => {
            setShowAddItemModal(false);
          }}
          from={"productProfile"}
          title={TEXT_ADD_PRODUCT}
        />
      )}
    </Box>
  );
};

export default Products;

